export default {
  phone: '',
  token: '',
  api_url: '',
  initial_message: '',
  chat_first_enabled: false,
  chat_first_daily_limit: 1
}
